import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Modal } from "@mantine/core";
import ConfigureMFA from "./ConfigureMFA";
import AsyncSwitch from "./AsyncSwitch";
import API from "../utilities/LocalApiProxy";
import { LexWorkplaceAdminOnlyWarning } from "./Settings/AdminOnlyWarning";
import { ButtonWithIcon } from "./ButtonWithIcon";
import { LexWorkplaceCheckIcon } from "./LexWorkplaceIcons";
import { VERIFY_TOTP_TOKEN_SUCCESS } from "../actions/types";
import { initMFA } from "../actions/userAuthActions";

const getMfaSettings = () => {
	return API.get("/mfaSettingsForFirmAndUser").then((res) => res.mysql);
};

const MfaSettingsPageComponent = ({ mfaConfiguredSuccess, initMFA }) => {
	const [loading, setLoading] = useState(true);
	const [dialogOpen, setDialogOpen] = useState(false);

	const [mfaIsRequiredForAllUsers, setMfaIsRequiredForAllUsers] =
		useState(false);
	const [mfaEnabledInCognito, setMfaEnabledInCognito] = useState(false);

	useEffect(() => {
		getMfaSettings()
			.then((res) => {
				setMfaIsRequiredForAllUsers(res.mfaRequiredInDb);
				setMfaEnabledInCognito(res.mfaEnabledInCognito);
				setLoading(false);
			})
			.catch((e) => {
				console.error("error in useEffect for MfaSettingsPage", e);
			});
	}, []);

	// Close dialog when MFA setup is successful
	useEffect(() => {
		if (mfaConfiguredSuccess && dialogOpen) {
			setDialogOpen(false);
			// Refresh MFA settings to show updated status
			getMfaSettings().then((res) => {
				setMfaEnabledInCognito(res.mfaEnabledInCognito);
			});
		}
	}, [mfaConfiguredSuccess, dialogOpen]);

	return (
		<div style={{ paddingLeft: 24 }}>
			<div style={{ marginBottom: 36 }}>
				<h3 style={{ marginBottom: 24 }}>Firm-Wide MFA Settings</h3>
				<div
					style={{ marginBottom: "20px", paddingLeft: 16 }}
					className="newCenter450"
				>
					<LexWorkplaceAdminOnlyWarning singular={true} />
					<AsyncSwitch
						label={"Require MFA for All Users"}
						switchValue={mfaIsRequiredForAllUsers}
						disabled={true}
						loading={loading}
					/>
				</div>
			</div>
			<div>
				<h3 style={{ marginBottom: 24 }}>My MFA Settings</h3>
				<div style={{ paddingLeft: 16 }}>
					{loading ? (
						<div>Loading...</div>
					) : (
						<div>
							<div style={{ marginBottom: 16 }}>
								{mfaEnabledInCognito
									? "You currently have MFA enabled for your LexWorkplace Login. You can reconfigure it (for instance if you got a new phone) by clicking below."
									: "You currently do not have MFA enabled for your LexWorkplace Login. You can setup MFA by clicking below."}
							</div>
							<ButtonWithIcon
								handler={() => {
									initMFA();
									setDialogOpen(true);
								}}
								buttonText={
									mfaEnabledInCognito
										? "Reconfigure MFA"
										: "Setup MFA"
								}
								iconComponent={<LexWorkplaceCheckIcon />}
								className="blue"
							/>
							<Modal
								opened={dialogOpen}
								onClose={() => setDialogOpen(false)}
								title={
									<span
										style={{
											textAlign: "center",
											width: "100%",
										}}
									>
										Configure Multi-Factor Authentication
									</span>
								}
								centered
							>
								<ConfigureMFA mode="optional" />
							</Modal>
						</div>
					)}
				</div>
			</div>
		</div>
	);
};

const mapStateToProps = (state) => ({
	mfaConfiguredSuccess: state.user.authState === VERIFY_TOTP_TOKEN_SUCCESS,
});

export const MfaSettingsPage = connect(mapStateToProps, { initMFA })(
	MfaSettingsPageComponent
);
